import { ConversationsState } from '../../../lib/conversations';
import { Me } from '../../../lib/me';
import { usePageLoadBi } from '../../../lib/use-page-load-bi';
import { MobileSidebar } from './mobile/MobileSidebar';
import { WideSidebar } from './WideSidebar';
import type { NavId } from './hooks/use-sidebar-nav';

/**
 * The sidebar's ONE decision: which UI the viewport gets.
 *
 * Wide is a light floating rail that collapses to an icon strip; narrow is the
 * dark mobile drawer from the Figma design (`7593:24422`). They diverged far
 * enough that parameterising one tree meant a `narrow ?` on nearly every line, so
 * they are two standalone components — and every piece of shared LOGIC (which
 * destinations exist, the workspace rows, recent chats, credits, the account) lives
 * in ./hooks, which both read.
 */
export function Sidebar({
  state,
  selectedId,
  navCurrent,
  me,
  narrow,
  isOpen,
  onRequestClose,
  elevated = false,
  collapsed = false,
  onExpand,
  onOpenSearch,
}: {
  state: ConversationsState;
  selectedId: string | null;
  navCurrent?: NavId;
  me: Me | null;
  narrow: boolean;
  isOpen: boolean;
  onRequestClose?: () => void;
  elevated?: boolean;
  collapsed?: boolean;
  onExpand?: () => void;
  onOpenSearch?: () => void;
}) {
  usePageLoadBi({ page_name: 'menu', origin: 'menu' });

  if (narrow) {
    return (
      <MobileSidebar
        state={state}
        selectedId={selectedId}
        navCurrent={navCurrent}
        me={me}
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        elevated={elevated}
        onOpenSearch={onOpenSearch}
      />
    );
  }

  return (
    <WideSidebar
      state={state}
      selectedId={selectedId}
      navCurrent={navCurrent}
      me={me}
      collapsed={collapsed}
      onExpand={onExpand}
      onOpenSearch={onOpenSearch}
    />
  );
}
